import React, { useEffect, useState } from 'react';
import { scrollToTop } from '../utils';
import PoliticsComercialBike from '../components/Politics/PoliticsComercialBike';
import PoliticsComercialPesca from '../components/Politics/PoliticsComercialPesca';
const Politics = () => {
    const [filialSelecionada, setFilialSelecionada] = useState('');

    useEffect(() => {
        scrollToTop();

        // Captura o valor do cookie _filialSelecionada
        const cookies = document.cookie.split('; ');
        const filialCookie = cookies.find(row => row.startsWith('_filialSelecionada='));
        if (filialCookie) {
            setFilialSelecionada(filialCookie.split('=')[1]);
        }
    }, []);

    return (
        <>
            {filialSelecionada === '2' ? <PoliticsComercialBike /> : <PoliticsComercialPesca />}
        </>
    );
}

export default Politics;
